import React, { useState, useEffect } from 'react';
import { ShoppingCart, Package, Eye } from 'lucide-react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { COLLECTIONS } from '../../firebase/collections';
import { updateOrder } from '../../services/firestoreService';

const PurchasesManagement = () => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    loadPurchases();
  }, []);

  const loadPurchases = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, COLLECTIONS.ORDERS), where('type', 'in', ['purchase', 'multiple']));
      const querySnapshot = await getDocs(q);
      const purchasesData = [];
      querySnapshot.forEach((doc) => {
        purchasesData.push({ id: doc.id, ...doc.data() });
      });
      setPurchases(purchasesData.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds));
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, status) => {
    await updateOrder(id, { status });
    loadPurchases();
  };

  const filtered = filterStatus === 'all' ? purchases : purchases.filter(p => p.status === filterStatus);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-900">إدارة المشتريات</h1>
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex gap-2 flex-wrap">
          {['all', 'pending', 'processing', 'completed', 'cancelled'].map((status) => (
            <button key={status} onClick={() => setFilterStatus(status)} className={`px-4 py-2 rounded-lg font-medium ${filterStatus === status ? 'bg-yellow-500 text-white' : 'bg-gray-100 text-gray-700'}`}>
              {status === 'all' ? 'الكل' : status === 'pending' ? 'قيد الانتظار' : status === 'processing' ? 'قيد المعالجة' : status === 'completed' ? 'مكتمل' : 'ملغي'}
            </button>
          ))}
        </div>
      </div>
      {filtered.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((purchase) => (
            <div key={purchase.id} className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center gap-2 mb-4">
                <ShoppingCart className="w-5 h-5 text-blue-600" />
                <span className="font-bold">#{purchase.id?.slice(0, 8)}</span>
              </div>
              <p className="font-medium mb-2">{String(purchase.customerName || '')}</p>
              <p className="text-sm text-gray-600 mb-2">{String(purchase.customerPhone || '')}</p>
              {purchase.items && <p className="text-sm text-gray-600 mb-4">عدد المنتجات: {purchase.items.length}</p>}
              <p className="text-2xl font-bold text-blue-600 mb-4">${Number(purchase.total || 0).toFixed(2)}</p>
              <select value={purchase.status} onChange={(e) => handleStatusChange(purchase.id, e.target.value)} className="w-full px-3 py-2 border rounded-lg mb-2">
                <option value="pending">قيد الانتظار</option>
                <option value="processing">قيد المعالجة</option>
                <option value="completed">مكتمل</option>
                <option value="cancelled">ملغي</option>
              </select>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-md p-12 text-center"><Package className="w-16 h-16 mx-auto mb-4 text-gray-300" /><p>لا توجد مشتريات</p></div>
      )}
    </div>
  );
};

export default PurchasesManagement;
